import {
  Component,
  OnInit,
  Input,
  Output,
  ChangeDetectionStrategy,
  EventEmitter,
  OnDestroy,
  OnChanges,
} from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';
import { DateManagerService } from 'src/app/shared/services/date-manager/date-manager.service';
import { TransactionsService } from '../../../core/functions/transactions.service';
import { takeUntil } from 'rxjs/operators';
import { MatDialog } from '@angular/material';
import { SetTargetModalComponent } from '../set-target-modal/set-target-modal.component';

const TABLE_BALANCE_HEADERS = [
  {
    name: 'date',
    displayName: 'transactions.Date',
    type: 'date',
  },
  {
    name: 'amount',
    displayName: 'transactions.Amount',
    type: 'number',
  },
];
@Component({
  selector: 'makaw-balance',
  templateUrl: './balance.component.html',
  styleUrls: ['./balance.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BalanceComponent implements OnInit, OnDestroy {
  @Input() transaction$: Observable<any[]>;
  @Input() requestTarget$: Observable<boolean>;
  @Output() balanceOutput = new EventEmitter<any>();
  @Output() closeModal = new EventEmitter<any>();

  public balance: number;
  public transactions;
  private destroyed$ = new Subject();

  public dataSet: any[] = [];
  public dataSet$ = new BehaviorSubject<any[]>([]);
  public existDataSet = false;
  public tableHeaders = TABLE_BALANCE_HEADERS;
  public titleTableAcumulated = 'transactions.acumulated';

  constructor(
    private readonly transactionCalculationLibrary: TransactionsService,
    private readonly datesManagerLibrary: DateManagerService,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.transaction$
      .pipe(takeUntil(this.destroyed$))
      .subscribe((transactions) => {
        this.transactions = transactions;
        this._calculateBalance();
      });

    this.requestTarget$.subscribe((openModal) => {
      if (openModal) {
        const dataSentToModal: any = {};
        const dataSet = JSON.parse(JSON.stringify(this.dataSet));
        dataSentToModal.dataSet = dataSet;
        dataSentToModal.action = 'Set Goal';
        dataSentToModal.msg = 'transactions.setTarget';
        dataSentToModal.loaded = false;
        const dialogRef = this.dialog.open(SetTargetModalComponent, {
          width: '1000px',
          data: dataSentToModal,
        });

        dialogRef.afterClosed().subscribe((result) => {
          this.closeModal.emit();
        });
      }
    });
  }

  ngOnDestroy() {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  private _calculateBalance() {
    const formateddates = this.transactionCalculationLibrary.groupAndFormatByDates(
      this.datesManagerLibrary.datesFormaterByDay,
      this.transactions
    );
    const dates = this.transactionCalculationLibrary.groupByDates(
      this.transactions
    );
    const transactionsFormated = this.transactionCalculationLibrary.transactionsDateFormater(
      this.datesManagerLibrary.datesFormaterByDay,
      this.transactions
    );

    const acumulatedByDates = this.transactionCalculationLibrary.calculateAcumulatedByDates(
      formateddates,
      transactionsFormated
    );

    this.existDataSet = this._createDataSet(dates, acumulatedByDates);
    this.balance = this.existDataSet
      ? this.transactionCalculationLibrary.getBalance(
          this.transactionCalculationLibrary.groupByDates(this.transactions),
          acumulatedByDates
        )
      : 0;

    this.balanceOutput.emit(this.balance);
  }

  private _createDataSet(dates, acumulated): boolean {
    if (dates.length !== acumulated.length || dates.length === 0) {
      this.dataSet = [];
      this.dataSet$.next(this.dataSet);
      return false;
    }
    this.dataSet = [];

    for (let i = 0; i < dates.length; i++) {
      const item = {
        amount: acumulated[i],
        date: dates[i],
      };
      this.dataSet.push(item);
    }
    this.dataSet = this.dataSet.reverse();
    this.dataSet$.next(this.dataSet);
    return true;
  }
}
